import React, { useEffect, useState } from 'react';
import { InputLabel, Input } from '@material-ui/core';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import './DisplayPanelAccordian.css';
import { useSelector } from 'react-redux';

const DisplayPanelAccordianInformation = (props) => {
  const { mode = '', accordianObject, onClickRevise, onClickReview, isPermission = false, onClickReviseIcon } = props;
  const { responseObject } = useSelector((state) => state.DisplayPaneThreeReducer);
  const {
    labelTextOneOne = '',
    labelTextOneOneBadges = [],
    IconOne,
    IconTwo,
    textOneOne = '',
    multiline = false,
    isMultiInfoCard = false,
    isReviewLink = false,
    isResetIcon,
    IconReset,
    isAddIcon,
    IconResetEnable
  } = accordianObject;
  const [selectedBadge, setSelectedBadge] = useState('');
  const [information, setInformation] = useState('');
  const [selectedBadgeArray, setSelectedBadgeArray] = useState([]);
  const reviewLabelClass = isReviewLink ? 'reviewLinkText' : '';

  useEffect(() => {
    if (
      labelTextOneOneBadges[0]?.labelTextOneOneBadge === 'primary' ||
      labelTextOneOneBadges[0]?.labelTextOneOneBadge === ''
    ) {
      setSelectedBadge(labelTextOneOneBadges[0]);
    } else {
      setSelectedBadge('');
      setSelectedBadgeArray([]);
    }
  }, [responseObject]);
  const useStyles = makeStyles({
    root: {
      '&:hover': {
        backgroundColor: 'red'
      }
    }
  });
  const classes = useStyles();
  return (
    <>
      {isMultiInfoCard ? (
        <>
          <div className={'detailsContactContainer'}>
            <div className={'detsailsPadding'}>
              <div
                style={{
                  height:
                    multiline &&
                      selectedBadge &&
                      selectedBadge.textOne &&
                      selectedBadge.textOne.length > 40
                      ? '105px'
                      : '50px'
                }}
                className={['FormBox', 'detailsHeight'].join(' ')}
              >
                <div className={['formControlReviewName', 'formControlRight'].join(' ')}>
                  <div style={{ width: '100%' }}>
                    <InputLabel
                      htmlFor="name-input"
                      className={['textForLabel', 'textForLabelRight', 'careerLabelRight'].join(
                        ' '
                      )}
                    >
                      <span
                        style={{
                          marginBottom: labelTextOneOneBadges.length > 0 ? '0' : '5px',
                          display: 'inline-block'
                        }}
                        className={mode === 'revise' ? 'linkText' : reviewLabelClass}
                        onClick={
                          mode === 'revise'
                            ? (e) => {
                              onClickRevise(e, selectedBadgeArray, selectedBadge);
                            }
                            : (e) => {
                              onClickReview(e);
                            }
                        }
                        data-value={labelTextOneOne}
                        data-key={selectedBadge?.labelTextTwoBadge || ''}
                      >
                        {labelTextOneOne}
                      </span>
                      {/* {labelTextOneOne === 'sign-in' && (
                        <sup
                          key={`badge-sign-in`}
                          style={{
                            backgroundColor: '#F2F2F2'
                          }}
                        >
                          credential
                        </sup>
                      )} */}
                      {selectedBadgeArray.length > 0 &&
                        selectedBadgeArray.map((val, i) => {
                          return (
                            <sup
                              key={`badge-sign-in${i}`}
                              style={{
                                backgroundColor: '#F2F2F2'
                              }}
                              onClick={() => {
                                console.log('listtt');
                                setSelectedBadge('');
                                setInformation('');
                                let removeLastOb = selectedBadgeArray.slice(0, -1);
                                setSelectedBadgeArray(removeLastOb);
                              }}
                            >
                              {val.labelTextTwoBadge}
                            </sup>
                          );
                        })}
                      {selectedBadgeArray.length > 0 ? (
                        <>
                          {selectedBadgeArray[
                            selectedBadgeArray.length - 1
                          ].innerLabelBadgeList.map((ob, key) => {
                            return (
                              <React.Fragment key={key}>
                                {ob.labelTextTwoBadge !== '' ? (
                                  <sup
                                    key={`badge-${key}`}
                                    style={{
                                      backgroundColor:
                                        selectedBadge &&
                                          selectedBadge.labelTextTwoBadge === ob.labelTextTwoBadge
                                          ? '#F2F2F2'
                                          : '#ffffff'
                                    }}
                                    onClick={(e) => {
                                      if (Array.isArray(ob.innerLabelBadgeList)) {
                                        setSelectedBadgeArray((state) => {
                                          return [...state, ob];
                                        });
                                      } else {
                                        setSelectedBadge(ob);
                                        setInformation(ob.innerLabelInformation);
                                      }
                                    }}
                                  >
                                    {ob.labelTextTwoBadge}
                                  </sup>
                                ) : (
                                  <></>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {labelTextOneOneBadges.map((ob, key) => {
                            return (
                              <React.Fragment key={key}>
                                {ob.labelTextTwoBadge !== '' ? (
                                  <sup
                                    key={`badge-${key}`}
                                    style={{
                                      backgroundColor:
                                        selectedBadge &&
                                          selectedBadge.labelTextTwoBadge === ob.labelTextTwoBadge
                                          ? '#F2F2F2'
                                          : '#ffffff'
                                    }}
                                    onClick={() => {
                                      console.log('HERE===', ob);
                                      if (Array.isArray(ob.innerLabelBadgeList)) {
                                        setSelectedBadgeArray((state) => {
                                          return [...state, ob];
                                        });
                                      } else {
                                        console.log('LIST==', ob);
                                        setSelectedBadge(ob);
                                      }
                                    }}
                                  >
                                    {ob.labelTextTwoBadge}
                                  </sup>
                                ) : (
                                  <></>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      )}
                    </InputLabel>
                    {textOneOne ||
                      (selectedBadge && selectedBadge.innerLabelBadgeList && (
                        <Input
                          multiline={
                            multiline &&
                            selectedBadge.innerLabelBadgeList &&
                            selectedBadge.innerLabelBadgeList.length > 40
                          }
                          // row={multiline ? 2 : 1}
                          row={2}
                          maxRows={
                            multiline &&
                              selectedBadge.innerLabelBadgeList &&
                              selectedBadge.innerLabelBadgeList.length > 40
                              ? 4
                              : 1
                          }
                          className={'inputText'}
                          id="name-dn-input12"
                          value={selectedBadge?.innerLabelBadgeList || 'No'}
                          disableUnderline={true}
                          readOnly
                        />
                      ))}
                  </div>
                </div>
                <div className={'unitFlex'}>
                  {isPermission && information ? (
                    <span
                      className={[
                        'unitFlex',
                        'iconsFooterLabelDefault',
                        'AssesseeNotifyStatus'
                      ].join(' ')}
                      style={{ textAlign: 'center' }}
                    >
                      {information}
                      <InputLabel
                        className={['iconsFooterLabelDefault', 'AssesseeNotifyStatusLabel'].join(
                          ' '
                        )}
                      >
                        {'information'}
                      </InputLabel>
                    </span>
                  ) : null}
                  {isResetIcon && IconReset ? (
                    // <Tooltip>
                    <div {...(IconResetEnable && {title: 'click to update changes'})}>
                      <IconButton
                        style={{ display: mode === 'revise' ? 'block' : 'none' }}
                        onClick={
                          mode === 'revise'
                            ? () => {
                              // onClickRevise(e,'',
                              //   //selectedBadge?.labelTextOneOneBadge || ''
                              //   )
                              onClickReview(
                                labelTextOneOne,
                                selectedBadge?.labelTextOneOneBadge || ''
                              );
                            }
                            : () => {
                              onClickReview(
                                labelTextOneOne,
                                selectedBadge?.labelTextOneOneBadge || ''
                              );
                            }
                        }
                        disabled={IconResetEnable ? false : true}
                      >
                        <IconReset
                          className={
                            mode === 'revise'
                              ? IconResetEnable
                                ? 'linkText'
                                : reviewLabelClass
                              : reviewLabelClass
                          }
                        />
                      </IconButton>
                    </div>
                    // </Tooltip>
                  ) : null}
                </div>
                <div className={['unitFlex', 'unitFlexTop'].join(' ')}>
                  {selectedBadge?.IconOne ? (
                    <>
                      <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                        <IconButton
                          // style={{ display: mode === 'revise' ? 'block' : 'none' }}
                          onClick={
                            mode === 'revise'
                              ? () => {
                                onClickReview(
                                  labelTextOneOne,
                                  selectedBadge?.labelTextTwoBadge || ''
                                );
                              }
                              : null
                            // : () => {
                            //     onClickReview(
                            //       labelTextOneOne,
                            //       selectedBadge?.labelTextOneOneBadge || ''
                            //     );
                            // }
                          }
                        >
                          <selectedBadge.IconOne
                            className={
                              mode === 'revise'
                                ? ['linkText', 'iconOne'].join(' ')
                                : reviewLabelClass
                            }
                          />
                        </IconButton>
                      </div>
                    </>
                  ) : (
                    <>
                      {IconOne && (
                        <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                          <IconButton
                            style={{ display: mode === 'revise' ? 'block' : 'none' }}
                            onClick={
                              mode === 'revise'
                                ? () => {
                                  // onClickRevise(e,'',
                                  //   //selectedBadge?.labelTextOneOneBadge || ''
                                  //   )
                                  onClickReview(
                                    labelTextOneOne,
                                    selectedBadge?.labelTextOneOneBadge || ''
                                  );
                                }
                                : () => {
                                  onClickReview(
                                    labelTextOneOne,
                                    selectedBadge?.labelTextOneOneBadge || ''
                                  );
                                }
                            }
                          >
                            <IconOne
                            //className={mode === 'revise' ? 'linkText' : reviewLabelClass}
                            />
                          </IconButton>
                        </div>
                      )}
                    </>
                  )}
                  {selectedBadge.IconTwo ? (
                    <>
                      <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                        <IconButton>
                          <selectedBadge.IconTwo />
                        </IconButton>
                      </div>
                    </>
                  ) : (
                    <>
                      {IconTwo && (
                        <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                          <IconButton>
                            <IconTwo />
                          </IconButton>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={'detailsContactContainer'}>
          <div className={'detsailsPadding'}>
            <div
              style={{
                height:
                  multiline &&
                    ((textOneOne && textOneOne.length > 40) ||
                      (selectedBadge && selectedBadge.textOne && selectedBadge.textOne.length > 40))
                    ? '105px'
                    : '50px'
              }}
              className={['FormBox', 'detailsHeight-two'].join(' ')}
            >
              <div className={['formControlReviewName', 'formControlRight'].join(' ')}>
                <div style={{ width: '100%' }}>
                  <InputLabel
                    htmlFor="name-input"
                    className={['textForLabel', 'textForLabelRight', 'careerLabelRight'].join(' ')}
                  >
                    <span
                      style={{
                        marginBottom: labelTextOneOneBadges.length > 0 ? '0' : '5px',
                        display: 'inline-block'
                      }}
                      className={mode === 'revise' ? 'linkText' : reviewLabelClass}
                      onClick={mode === 'revise' ? onClickRevise : onClickReview}
                      data-value={labelTextOneOne}
                      data-key={selectedBadge?.labelTextOneOneBadge || ''}
                    >
                      {labelTextOneOne}
                    </span>
                    {/* {labelTextOneOne === 'sign-in' && (
                      <sup
                        key={`badge-sign-in`}
                        style={{
                          backgroundColor: '#F2F2F2'
                        }}
                      >
                        credential
                      </sup>
                    )} */}
                    {labelTextOneOneBadges.map((ob, key) => {
                      return (
                        <React.Fragment key={key}>
                          {ob.labelTextOneOneBadge !== '' ? (
                            <sup
                              key={`badge-${key}`}
                              style={{
                                backgroundColor:
                                  selectedBadge &&
                                    selectedBadge.labelTextOneOneBadge === ob.labelTextOneOneBadge
                                    ? '#F2F2F2'
                                    : '#ffffff'
                              }}
                              onClick={() => {
                                selectedBadge === ob ? setSelectedBadge('') : setSelectedBadge(ob);
                                // selectedBadge === '' ? setSelectedBadge(ob) : setSelectedBadge('');
                              }}
                            >
                              {ob.labelTextOneOneBadge}
                            </sup>
                          ) : (
                            <></>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </InputLabel>
                  {(textOneOne || (selectedBadge && selectedBadge.textOne)) && (
                    <Input
                      multiline={
                        multiline &&
                        ((textOneOne && textOneOne.length > 40) ||
                          (selectedBadge.textOne && selectedBadge.textOne.length > 40))
                      }
                      row={2}
                      maxRows={
                        //multiline && selectedBadge.textOne && selectedBadge.textOne.length > 40
                        multiline &&
                          ((textOneOne && textOneOne.length > 40) ||
                            (selectedBadge.textOne && selectedBadge.textOne.length > 40))
                          ? 4
                          : 1
                      }
                      className={'inputText'}
                      id="name-dn-input34"
                      value={(selectedBadge && selectedBadge.textOne) || textOneOne}
                      disableUnderline={true}
                      readOnly
                    />
                  )}
                </div>
              </div>
              <div className={'unitFlex'}></div>
              <div className={['unitFlex', 'unitFlexTop'].join(' ')} >
                {selectedBadge?.IconOne ? (
                  <>
                    <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                      <IconButton
                      style={{fontSize: "20px"}}
                        onClick={
                          mode === 'revise'
                            ? () => {
                              onClickReview(
                                labelTextOneOne,
                                selectedBadge?.labelTextOneOneBadge || ''
                              );
                            }
                            : () => {
                              onClickReview(
                                labelTextOneOne,
                                selectedBadge?.labelTextOneOneBadge || ''
                              );
                            }
                        }
                      >
                        <selectedBadge.IconOne style={{fontSize: "20px"}}/>
                      </IconButton>
                    </div>
                  </>
                ) : (
                  <>
                    {IconOne && (
                      <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')} >
                        <IconButton
                        style={{fontSize: "20px"}}
                          onClick={
                            mode === 'revise'
                              ? () => {
                                onClickReviseIcon(
                                  labelTextOneOne,
                                  selectedBadge?.labelTextOneOneBadge || ''
                                );
                              }
                              : () => {
                                onClickReviseIcon(
                                  labelTextOneOne,
                                  selectedBadge?.labelTextOneOneBadge || ''
                                );
                              }
                          }
                        >
                          <IconOne style={{fontSize: "20px"}}/>
                        </IconButton>
                      </div>
                    )}
                    {isAddIcon && (
                      <div className={['unitFlex', 'verifiedUser', ''].join(' ')}>
                        <InputLabel htmlFor="name-input" className={[''].join(' ')}>
                          create
                        </InputLabel>
                      </div>
                    )}
                  </>
                )}
                {selectedBadge.IconTwo ? (
                  <>
                    <div
                      className={[
                        'unitFlex',
                        'verifiedUser',
                        'verifiedUserTop',
                        'iguru-icons-icon-adjst'
                      ].join(' ')}
                    >
                      {/* all > className={classes.root}*/}
                      <IconButton style={{fontSize: "20px"}}>
                        <selectedBadge.IconTwo style={{fontSize: "20px"}}/>
                      </IconButton>
                    </div>
                  </>
                ) : (
                  <>
                    {IconTwo && (
                      <div
                        className={[
                          'unitFlex',
                          'verifiedUser',
                          'verifiedUserTop',
                          'iguru-icons-icon-adjst'
                        ].join(' ')}
                      >
                        {/* key */}
                        <IconButton style={{fontSize: "20px"}}>
                          <IconTwo style={{fontSize: "20px"}}/>
                        </IconButton>
                      </div>
                    )}
                  </>
                )}
                {/* {IconOne && (
              <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                <IconButton
                  onClick={
                    mode === 'revise'
                      ? () => {}
                      : () => {
                          onClickReview(labelTextOneOne, selectedBadge?.labelTextOneOneBadge || '');
                        }
                  }
                >
                  <IconOn
                  e />
                </IconButton>
              </div>
            )} */}
                {/* {IconTwo && (
              <div className={['unitFlex', 'verifiedUser', 'verifiedUserTop'].join(' ')}>
                <IconButton>
                  <IconTwo />
                </IconButton>
              </div>
            )} */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DisplayPanelAccordianInformation;
